<app-progress-spinner *ngIf="!showGrid || submitted"></app-progress-spinner>
<div class="container">
    <div style="overflow-x: scroll; overflow-y: hidden; white-space: nowrap;">
        <!-- <div> -->
        <div class="dynamicConfigGrid" [style.width]="getsummaryGridWidth()"
            style="width: 850px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px; position: sticky; left: 0; z-index: 2;">
            <div class="label-header">
                <label class="label-headereq">Configuration</label>
            </div>
        </div>

        <div [style.width.px]="refGridOpened ? 300 : 40"
            style="margin-left: 5px; display: inline-block; margin-top: 0px; transition: width 0.3s ease;">
            <div class="label-header" style="align-items: center; justify-content: space-between;">

                <!-- Show label + input only if expanded -->
                <ng-container *ngIf="refGridOpened">
                    <label class="label-headereq" style="white-space: nowrap;">
                        Reference Scenario:
                        <input [(ngModel)]="refTitle" (ngModelChange)="onRefTitleRawChange($event)" type="text"
                            placeholder="Add Title" [readonly]="!isEditable" [disabled]="!isEditable"
                            [style.cursor]="isEditable ? 'text' : 'default'"
                            style="background-color: transparent; border: none; color: white; font-weight: 600; font-size: 1em;">
                    </label>
                </ng-container>

                <!-- Arrow toggle always visible -->
                <button aria-label="Arrow" [style.margin-left.px]="refGridOpened ? 23 : 12"
                    style="width: 20px; height: 25px; background-color: transparent;" class="navbar-toggle"
                    (click)="toggleRefGrid()">
                    <img alt="LeftArrow" *ngIf="refGridOpened" src="../assets/icons/LeftArrow.png" class="arrow-style"
                        _ngcontent-abd-c12>
                    <img alt="RightArrow" *ngIf="!refGridOpened" src="../assets/icons/RightArrow.png"
                        class="arrow-style" _ngcontent-abd-c12>
                </button>

            </div>
        </div>


        <!-- Target Scenario Label Block -->
        <div [style.width.px]="tarGridOpened ? 650 : 40"
            style="margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px; transition: width 0.3s ease;">
            <div class="label-header" style="align-items: center; justify-content: space-between;">

                <!-- Only show label & input when expanded -->
                <ng-container *ngIf="tarGridOpened">
                    <label class="label-headereq" style="white-space: nowrap;">
                        Target Scenario:
                        <input [(ngModel)]="tarTitle" (ngModelChange)="onTarTitleRawChange($event)" type="text"
                            placeholder="Add Title" [readonly]="!isEditable" [disabled]="!isEditable"
                            [style.cursor]="isEditable ? 'text' : 'default'"
                            style="background-color: transparent; border: none; color: white; font-weight: 600; font-size: 1em;">
                    </label>
                </ng-container>

                <!-- Arrow toggle button -->
                <button aria-label="Arrow" [style.margin-left.px]="tarGridOpened ? 395 : 12"
                    style="width: 20px; height: 25px; background-color: transparent;" class="navbar-toggle"
                    (click)="toggleTarGrid()">
                    <img alt="LeftArrow" *ngIf="tarGridOpened" src="../assets/icons/LeftArrow.png" class="arrow-style"
                        _ngcontent-abd-c12>
                    <img alt="RightArrow" *ngIf="!tarGridOpened" src="../assets/icons/RightArrow.png"
                        class="arrow-style" _ngcontent-abd-c12>
                </button>

            </div>
        </div>


        <!-- Option A Block -->
        <div *ngIf="optAVisible" [style.width.px]="optAGridOpened ? 650 : 40"
            style="margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px; transition: width 0.3s ease;">
            <div class="label-header" style="align-items: center; justify-content: space-between;">

                <!-- Only show label and input when expanded -->
                <ng-container *ngIf="optAGridOpened">
                    <label class="label-headereq" style="white-space: nowrap;">
                        Option A: {{ targetTitle }}
                        <input [(ngModel)]="optATitle" (ngModelChange)="onOptATitleRawChange($event)" type="text"
                            placeholder="Add Title" [readonly]="!isEditable" [disabled]="!isEditable"
                            [style.cursor]="isEditable ? 'text' : 'default'"
                            style="background-color: transparent; border: none; color: white; font-weight: 600; font-size: 1em;">
                    </label>
                </ng-container>

                <!-- Toggle button -->
                <button aria-label="Arrow" [style.margin-left.px]="optAGridOpened ? 428 : 12"
                    style="width: 20px; height: 25px; background-color: transparent;" class="navbar-toggle"
                    (click)="toggleOptAGrid()">
                    <img alt="LeftArrow" *ngIf="optAGridOpened" src="../assets/icons/LeftArrow.png" class="arrow-style"
                        _ngcontent-abd-c12>
                    <img alt="RightArrow" *ngIf="!optAGridOpened" src="../assets/icons/RightArrow.png"
                        class="arrow-style" _ngcontent-abd-c12>
                </button>

            </div>
        </div>


        <div *ngIf="optBVisible" [style.width.px]="optBGridOpened ? 650 : 40"
            style="margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px; transition: width 0.3s ease;">
            <div class="label-header" style="align-items: center; justify-content: space-between;">

                <!-- Show label and input only when expanded -->
                <ng-container *ngIf="optBGridOpened">
                    <label class="label-headereq" style="white-space: nowrap;">
                        Option B: {{ targetTitle }}
                        <input [(ngModel)]="optBTitle" (ngModelChange)="onOptBTitleRawChange($event)" type="text"
                            placeholder="Add Title" [readonly]="!isEditable" [disabled]="!isEditable"
                            [style.cursor]="isEditable ? 'text' : 'default'"
                            style="background-color: transparent; border: none; color: white; font-weight: 600; font-size: 1em;">
                    </label>
                </ng-container>

                <!-- Toggle arrow button -->
                <button aria-label="Arrow" [style.margin-left.px]="optBGridOpened ? 428 : 12"
                    style="width: 20px; height: 25px; background-color: transparent; " class="navbar-toggle"
                    (click)="toggleOptBGrid()">
                    <img alt="LeftArrow" *ngIf="optBGridOpened" src="../assets/icons/LeftArrow.png" class="arrow-style"
                        _ngcontent-abd-c12>
                    <img alt="RightArrow" *ngIf="!optBGridOpened" src="../assets/icons/RightArrow.png"
                        class="arrow-style" _ngcontent-abd-c12>
                </button>

            </div>
        </div>


        <div *ngIf="optCVisible" [style.width.px]="optCGridOpened ? 650 : 40"
            style="margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px; transition: width 0.3s ease;">
            <div class="label-header" style="align-items: center; justify-content: space-between;">

                <!-- Show label and input only when expanded -->
                <ng-container *ngIf="optCGridOpened">
                    <label class="label-headereq" style="white-space: nowrap;">
                        Option C: {{ targetTitle }}
                        <input [(ngModel)]="optCTitle" (ngModelChange)="onOptCTitleRawChange($event)" type="text"
                            placeholder="Add Title" [readonly]="!isEditable" [disabled]="!isEditable"
                            [style.cursor]="isEditable ? 'text' : 'default'"
                            style="background-color: transparent; border: none; color: white; font-weight: 600; font-size: 1em;">
                    </label>
                </ng-container>

                <!-- Toggle arrow button -->
                <button aria-label="Arrow" [style.margin-left.px]="optCGridOpened ? 428 : 12"
                    style="width: 20px; height: 25px; background-color: transparent;" class="navbar-toggle"
                    (click)="toggleOptCGrid()">
                    <img alt="LeftArrow" *ngIf="optCGridOpened" src="../assets/icons/LeftArrow.png" class="arrow-style"
                        _ngcontent-abd-c12>
                    <img alt="RightArrow" *ngIf="!optCGridOpened" src="../assets/icons/RightArrow.png"
                        class="arrow-style" _ngcontent-abd-c12>
                </button>

            </div>
        </div>


        <div class="col-md-1 col-lg-1"
            style="margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px;">
            <div class="label-header">
                <button id="addOption" [disabled]="!isEditable || !isVisibleAddOption"
                    [ngClass]="{ 'click-not-allowed': !isEditable || !isVisibleAddOption }" (click)="addNewRow()"
                    title="Add">
                    <img alt="plusIcon" src="../assets/icons/Plus.svg" height="25" width="25" class="icon-add" />
                    <label class="label-headereq">add Option</label>
                </button>
            </div>
        </div>
        <!-- </div> -->
        <br id="br-summary">
        <!-- <div style="margin-top: -10px;"> -->

        <div class="dynamicConfigGrid summary" [style.width]="getsummaryGridWidth()"
            style="width: 850px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px; position: sticky; left: 0; z-index: 2;">
            <ag-grid-angular #configGridSummary *ngIf="showGrid" style="width: 100%;" class="ag-theme-alpine"
                id="configGridSummary" [rowData]="gridDataSummary" [columnDefs]="configColumnDefsSummary"
                [groupDefaultExpanded]="1" [groupUseEntireRow]="true" [domLayout]="domLayoutConfigSummary"
                [frameworkComponents]="frameworkComponents" [defaultColDef]="configDefaultColDefSummary"
                [enableBrowserTooltips]="true" [popupParent]="popupParent"
                (cellValueChanged)="onConfigCellValueChangedSummary($event)"
                (gridReady)="onConfigGridReadySummary($event)" (rowClicked)="onRowClicked($event)"
                (firstDataRendered)="onFirstDataRenderedConfigSummary($event)"
                [groupRowRendererParams]="groupRowRendererParamsSummary"
                (rowGroupOpened)="onConfigRowGroupOpenedSummary($event)"
                (gridSizeChanged)="onGridConfigChangedSummary($event)" [rowHeight]="getRowHeightConfigSummary"
                (displayedColumnsChanged)="onDisplayedColumnsChangedConfigSummary($event)">
            </ag-grid-angular>
        </div>


        <div class="summary " [style.width.px]="refGridOpened ? 300 : 40"
            [style.visibility]="refGridOpened ? 'visible' : 'hidden'"
            style="transition: width 0.3s ease; margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px;visibility:hidden;">
            <ag-grid-angular #refGridSummary *ngIf="showGrid" style="width: 100%;" class="ag-theme-alpine"
                id="refGridSummary" [rowData]="gridDataSummary" [columnDefs]="refColumnDefsSummary"
                [groupDefaultExpanded]="1" [groupUseEntireRow]="true" [domLayout]="domLayoutRefSummary"
                [frameworkComponents]="frameworkComponents" [defaultColDef]="refDefaultColDefSummary"
                [enableBrowserTooltips]="true" [popupParent]="popupParent"
                (cellValueChanged)="onRefCellValueChangedSummary($event)"
                [groupRowRendererParams]="groupRowRendererParamsSummary" (gridReady)="onRefGridReadySummary($event)"
                (rowGroupOpened)="onRefRowGroupOpenedSummary($event)"
                (gridSizeChanged)="onGridRefChangedSummary($event)" [rowHeight]="getRowHeightRefSummary"
                (displayedColumnsChanged)="onDisplayedColumnsChangedRefSummary($event)">
            </ag-grid-angular>
        </div>

        <div class="summary" [style.width.px]="tarGridOpened ? 650 : 40"
            [style.visibility]="tarGridOpened ? 'visible' : 'hidden'"
            style="width: 650px; margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px;">
            <ag-grid-angular #tarGridSummary *ngIf="showGrid" style="width: 100%;" class="ag-theme-alpine"
                id="tarGridSummary" [rowData]="gridDataSummary" [columnDefs]="tarColumnDefsSummary"
                [context]="agGridContext" [groupDefaultExpanded]="1" [groupUseEntireRow]="true"
                [domLayout]="domLayoutTarSummary" [frameworkComponents]="frameworkComponents"
                [defaultColDef]="tarDefaultColDefSummary" [enableBrowserTooltips]="true" [popupParent]="popupParent"
                (cellValueChanged)="onTarCellValueChangedSummary($event)"
                [groupRowRendererParams]="groupRowRendererParamsSummary" (gridReady)="onTarGridReadySummary($event)"
                (rowGroupOpened)="onTarRowGroupOpenedSummary($event)"
                (gridSizeChanged)="onGridTarChangedSummary($event)" [rowHeight]="getRowHeightTarSummary"
                (displayedColumnsChanged)="onDisplayedColumnsChangedTarSummary($event)">
            </ag-grid-angular>
        </div>

        <div *ngIf="optAVisible" class="summary" [style.width.px]="optAGridOpened ? 650 : 40"
            [style.visibility]="optAGridOpened ? 'visible' : 'hidden'"
            style="width: 650px; margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px;">
            <ag-grid-angular #optAGridSummary *ngIf="showGrid" style="width: 100%;" class="ag-theme-alpine"
                id="optAGridSummary" [rowData]="gridDataSummary" [columnDefs]="optAColumnDefsSummary"
                [context]="agGridContext" [groupDefaultExpanded]="1" [groupUseEntireRow]="true"
                [domLayout]="domLayoutOptASummary" [frameworkComponents]="frameworkComponents"
                [defaultColDef]="optADefaultColDefSummary" [enableBrowserTooltips]="true" [popupParent]="popupParent"
                (cellValueChanged)="onOptACellValueChangedSummary($event)"
                [groupRowRendererParams]="groupRowRendererParamsSummary" (gridReady)="onOptAGridReadySummary($event)"
                (rowGroupOpened)="onOptARowGroupOpenedSummary($event)"
                (gridSizeChanged)="onGridOptAChangedSummary($event)" [rowHeight]="getRowHeightOptASummary"
                (displayedColumnsChanged)="onDisplayedColumnsChangedOptASummary($event)">
            </ag-grid-angular>
        </div>

        <div *ngIf="optBVisible" class="summary" [style.width.px]="optBGridOpened ? 650 : 40"
            [style.visibility]="optBGridOpened ? 'visible' : 'hidden'"
            style="width: 650px; margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px;">
            <ag-grid-angular #optBGridSummary *ngIf="showGrid" style="width: 100%;" class="ag-theme-alpine"
                id="optBGridSummary" [rowData]="gridDataSummary" [columnDefs]="optBColumnDefsSummary"
                [context]="agGridContext" [groupDefaultExpanded]="1" [groupUseEntireRow]="true"
                [domLayout]="domLayoutOptBSummary" [frameworkComponents]="frameworkComponents"
                [defaultColDef]="optBDefaultColDefSummary" [enableBrowserTooltips]="true" [popupParent]="popupParent"
                (cellValueChanged)="onOptBCellValueChangedSummary($event)"
                [groupRowRendererParams]="groupRowRendererParamsSummary" (gridReady)="onOptBGridReadySummary($event)"
                (rowGroupOpened)="onOptBRowGroupOpenedSummary($event)"
                (gridSizeChanged)="onGridOptBChangedSummary($event)" [rowHeight]="getRowHeightOptBSummary"
                (displayedColumnsChanged)="onDisplayedColumnsChangedOptBSummary($event)">
            </ag-grid-angular>
        </div>

        <div *ngIf="optCVisible" class="summary" [style.width.px]="optCGridOpened ? 650 : 40"
            [style.visibility]="optCGridOpened ? 'visible' : 'hidden'"
            style="width: 650px; margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px;">
            <ag-grid-angular #optCGridSummary *ngIf="showGrid" style="width: 100%;" class="ag-theme-alpine"
                id="optCGridSummary" [rowData]="gridDataSummary" [columnDefs]="optCColumnDefsSummary"
                [context]="agGridContext" [groupDefaultExpanded]="1" [groupUseEntireRow]="true"
                [domLayout]="domLayoutOptCSummary" [frameworkComponents]="frameworkComponents"
                [defaultColDef]="optCDefaultColDefSummary" [enableBrowserTooltips]="true" [popupParent]="popupParent"
                (cellValueChanged)="onOptCCellValueChangedSummary($event)"
                [groupRowRendererParams]="groupRowRendererParamsSummary" (gridReady)="onOptCGridReadySummary($event)"
                (rowGroupOpened)="onOptCRowGroupOpenedSummary($event)"
                (gridSizeChanged)="onGridOptCChangedSummary($event)" [rowHeight]="getRowHeightOptCSummary"
                (displayedColumnsChanged)="onDisplayedColumnsChangedOptCSummary($event)">
            </ag-grid-angular>
        </div>
        <!-- </div> -->
        <br>
        <!-- <div style="margin-top: -10px;"> -->
        <div class="dynamicConfigGrid" [style.width]="getsummaryGridWidth()"
            style="width: 850px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px; position: sticky; left: 0; z-index: 2;">
            <ag-grid-angular #configGrid *ngIf="showGrid" style="width: 100%; height: 50vh; margin-top: 5px"
                class="ag-theme-alpine" id="configGrid" [rowData]="gridData" [columnDefs]="configColumnDefs"
                [getMainMenuItems]="getMainMenuItems.bind(this)" [groupUseEntireRow]="true"
                [rowGroupPanelShow]="rowGroupPanelShow" [suppressDragLeaveHidesColumns]="true"
                (columnRowGroupChanged)="onColumnRowGroupChanged($event)"
                [groupRowRendererParams]="groupRowRendererParams" [frameworkComponents]="frameworkComponents"
                [defaultColDef]="configDefaultColDef" [enableBrowserTooltips]="true" [popupParent]="popupParent"
                [rowClassRules]="rowClassRules" (cellValueChanged)="onConfigCellValueChanged($event)"
                (filterChanged)="onFilterChanged($event)" (sortChanged)="onSortChanged($event)"
                (gridReady)="onConfigGridReady($event)" (rowGroupOpened)="onConfigRowGroupOpened($event)"
                (gridSizeChanged)="onGridConfigChanged($event)" [rowHeight]="getRowHeightConfig"
                (columnVisible)="onColumnVisibleChanged($event)" [suppressColumnStateEvents]="false"
                [defaultGroupSortComparator]="defaultGroupSortComparator"
                (displayedColumnsChanged)="onDisplayedColumnsChangedConfig($event)"
                (firstDataRendered)="onFirstDataRendered($event, 'configGrid')"
                (columnResized)="onColumnResized($event)">
            </ag-grid-angular>
        </div>

        <div id="refG" [style.width.px]="refGridOpened ? 300 : 40"
            [style.visibility]="refGridOpened ? 'visible' : 'hidden'"
            style="width: 300px; margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px;">
            <ag-grid-angular #referenceGrid *ngIf="showGrid" style="width: 100%; height: 50vh; padding-top: 27px"
                class="ag-theme-alpine" id="refGrid" [rowData]="gridData" [columnDefs]="refColumnDefs"
                [getMainMenuItems]="getRefMainMenuItems.bind(this)" [suppressMakeColumnVisibleAfterUnGroup]="true"
                [groupSuppressAutoColumn]="true" [suppressAggFuncInHeader]="true"
                [frameworkComponents]="frameworkComponents" [defaultColDef]="refDefaultColDef"
                [enableBrowserTooltips]="true" [popupParent]="popupParent" [rowClassRules]="rowClassRules"
                (cellValueChanged)="onRefCellValueChanged($event)" (gridReady)="onRefGridReady($event)"
                (gridSizeChanged)="onGridRefChanged($event)" [rowHeight]="getRowHeightRef"
                [defaultGroupSortComparator]="defaultGroupSortComparator" (filterChanged)="onRefFilterChanged($event)"
                (sortChanged)="onSortChanged($event)" (displayedColumnsChanged)="onDisplayedColumnsChangedRef($event)"
                (firstDataRendered)="onFirstDataRendered($event, 'refGrid')">
            </ag-grid-angular>
        </div>

        <div id="tarG" [style.width.px]="tarGridOpened ? 650 : 40"
            [style.visibility]="tarGridOpened ? 'visible' : 'hidden'"
            style="width: 650px; margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px;">
            <ag-grid-angular #targetGrid *ngIf="showGrid" style="width: 100%; height: 50vh; padding-top: 27px"
                class="ag-theme-alpine" id="tarGrid" [rowData]="gridData" [columnDefs]="tarColumnDefs"
                [getMainMenuItems]="getTarMainMenuItems.bind(this)" [suppressMakeColumnVisibleAfterUnGroup]="true"
                [groupSuppressAutoColumn]="true" [suppressAggFuncInHeader]="true"
                [frameworkComponents]="frameworkComponents" [defaultColDef]="tarDefaultColDef"
                [enableBrowserTooltips]="true" [popupParent]="popupParent" [rowClassRules]="rowClassRules"
                (cellValueChanged)="onTarCellValueChanged($event)" (gridReady)="onTarGridReady($event)"
                (gridSizeChanged)="onGridTarChanged($event)" [rowHeight]="getRowHeightTar"
                [defaultGroupSortComparator]="defaultGroupSortComparator" (filterChanged)="onTarFilterChanged($event)"
                (sortChanged)="onSortChanged($event)" (displayedColumnsChanged)="onDisplayedColumnsChangedTar($event)"
                (firstDataRendered)="onFirstDataRendered($event, 'tarGrid')">
            </ag-grid-angular>
        </div>

        <div id="optAG" *ngIf="optAVisible" [style.width.px]="optAGridOpened ? 650 : 40"
            [style.visibility]="optAGridOpened ? 'visible' : 'hidden'"
            style="width: 650px; margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px;">
            <ag-grid-angular #optAGrid *ngIf="showGrid" style="width: 100%; height: 50vh; padding-top: 27px"
                class="ag-theme-alpine" id="optAGrid" [rowData]="gridData" [columnDefs]="optAColumnDefs"
                [getMainMenuItems]="getOptAMainMenuItems.bind(this)" [suppressMakeColumnVisibleAfterUnGroup]="true"
                [groupSuppressAutoColumn]="true" [suppressAggFuncInHeader]="true"
                [frameworkComponents]="frameworkComponents" [defaultColDef]="optADefaultColDef"
                [enableBrowserTooltips]="true" [popupParent]="popupParent" [rowClassRules]="rowClassRules"
                (cellValueChanged)="onOptACellValueChangedCS($event)" (gridReady)="onOptAGridReady($event)"
                (gridSizeChanged)="onGridOptAChanged($event)" [rowHeight]="getRowHeightoptA"
                [defaultGroupSortComparator]="defaultGroupSortComparator" (filterChanged)="onOptAFilterChanged($event)"
                (sortChanged)="onSortChanged($event)" (displayedColumnsChanged)="onDisplayedColumnsChangedOptA($event)"
                (firstDataRendered)="onFirstDataRendered($event, 'optAGrid')">
            </ag-grid-angular>
        </div>

        <div id="optBG" *ngIf="optBVisible" [style.width.px]="optBGridOpened ? 650 : 40"
            [style.visibility]="optBGridOpened ? 'visible' : 'hidden'"
            style="width: 650px; margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px;">
            <ag-grid-angular #optBGrid *ngIf="showGrid" style="width: 100%; height: 50vh; padding-top: 27px"
                class="ag-theme-alpine" id="optBGrid" [rowData]="gridData" [columnDefs]="optBColumnDefs"
                [getMainMenuItems]="getOptBMainMenuItems.bind(this)" [suppressMakeColumnVisibleAfterUnGroup]="true"
                [groupSuppressAutoColumn]="true" [suppressAggFuncInHeader]="true"
                [frameworkComponents]="frameworkComponents" [defaultColDef]="optBDefaultColDef"
                [enableBrowserTooltips]="true" [popupParent]="popupParent" [rowClassRules]="rowClassRules"
                (cellValueChanged)="onOptBCellValueChangedCS($event)" (gridReady)="onOptBGridReady($event)"
                (gridSizeChanged)="onGridOptBChanged($event)" [rowHeight]="getRowHeightoptB"
                [defaultGroupSortComparator]="defaultGroupSortComparator" (filterChanged)="onOptBFilterChanged($event)"
                (sortChanged)="onSortChanged($event)" (displayedColumnsChanged)="onDisplayedColumnsChangedOptB($event)"
                (firstDataRendered)="onFirstDataRendered($event,'optBGrid')">
            </ag-grid-angular>
        </div>

        <div id="optCG" *ngIf="optCVisible" [style.width.px]="optCGridOpened ? 650 : 40"
            [style.visibility]="optCGridOpened ? 'visible' : 'hidden'"
            style="width: 650px; margin-left: 5px; display: inline-block; padding-left: 0px; margin-top: 0px; padding-right: 0px;">
            <ag-grid-angular #optCGrid *ngIf="showGrid" style="width: 100%; height: 50vh; padding-top: 27px"
                class="ag-theme-alpine" id="optCGrid" [rowData]="gridData" [columnDefs]="optCColumnDefs"
                [getMainMenuItems]="getOptCMainMenuItems.bind(this)" [suppressMakeColumnVisibleAfterUnGroup]="true"
                [groupSuppressAutoColumn]="true" [suppressAggFuncInHeader]="true"
                [frameworkComponents]="frameworkComponents" [defaultColDef]="optCDefaultColDef"
                [enableBrowserTooltips]="true" [popupParent]="popupParent" [rowClassRules]="rowClassRules"
                (cellValueChanged)="onOptCCellValueChangedCS($event)" (gridReady)="onOptCGridReady($event)"
                (gridSizeChanged)="onGridOptCChanged($event)" [rowHeight]="getRowHeightoptC"
                [defaultGroupSortComparator]="defaultGroupSortComparator" (filterChanged)="onOptCFilterChanged($event)"
                (sortChanged)="onSortChanged($event)" (displayedColumnsChanged)="onDisplayedColumnsChangedOptC($event)"
                (firstDataRendered)="onFirstDataRendered($event,'optCGrid')">
            </ag-grid-angular>
        </div>
        <!-- </div> -->

    </div>
    <div class="row" style="margin-top:0px">
        <div class="offset-4 col-md-8">
            <div class="buttonStyle" style="float: right; margin-right: 5px; margin-bottom: -20px">
                <button id="expand-button" class="button button--small" (click)="onExpandCollapse()"
                    [disabled]="!isGrouped">
                    {{ expandCollapse }}</button>&nbsp;
                <!-- <button id="collapse-button" class="button button--small" (click)="onCollapse()">
                    Collapse Groups</button>&nbsp; -->
                <button id="focus-button" class="button button--small" (click)="onFocusView()">
                    Focus Mode</button>&nbsp;
                <button id="normal-button" class="button button--small" style="display: none;" (click)="onNormalView()">
                    Normal Mode</button>&nbsp;
                <button class="button button--small" (click)="onClickCancel()">
                    Cancel & Exit</button>&nbsp;
                <button class="button button--small" [disabled]="submitted" (click)="onClickBack()">
                    Back</button>&nbsp;
                <button class="button button--small" [disabled]="submitted" (click)="onClickNext()">
                    Next</button>&nbsp;
                <button class="button button--small" [disabled]="submitted || !canSave()" (click)="submit('save')">
                    Save</button>&nbsp;
                <button class="button button--small" [disabled]="submitted || !canSave()" (click)="submit($event)"
                    type="submit">
                    Save & Exit
                </button>
            </div>
        </div>
    </div>


    <br>
    <app-commentbox *ngIf="objData?.configurationId" #commentBox [configData]="objData"
        (unsavedChangesChange)="onCommentUnsavedChange($event)"></app-commentbox>


</div>